module.exports = __webpack_public_path__ + "img/close-square-on.43d4e726.svg";